import React from 'react';
import { SvgIconTypeMap } from '@mui/material/SvgIcon';
import PersonIcon from '@mui/icons-material/Person';
import BaseIconButton, { IBaseIconButtonProps } from './_module/BaseIconButton';

interface IProps extends IBaseIconButtonProps {
  status: boolean;
  iconFontSize?: SvgIconTypeMap['props']['fontSize'];
}

export default function UserStatusIconButton(props: IProps) {
  const { status, onClick, size, iconFontSize, tooltip, loading } = props;

  return (
    <BaseIconButton
      onClick={onClick}
      tooltip={tooltip}
      loading={loading}
      size={size || 'small'}
    >
      <PersonIcon
        htmlColor={status ? '#80C53A' : '#F92949'}
        fontSize={iconFontSize || 'small'}
      />
    </BaseIconButton>
  );
}
